import React, { useState } from "react";
import { useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import Card from "./Card";

export default function Column({ column, columns, setColumns }) {
    const [text, setText] = useState("");
    const { setNodeRef, isOver } = useDroppable({ id: column.id });

    const addCard = () => {
        if (!text.trim()) return;
        const newCard = { id: Date.now().toString(), text };
        setColumns(
            columns.map((c) =>
                c.id === column.id ? { ...c, cards: [...c.cards, newCard] } : c
            )
        );
        setText("");
    };

    return (
        <div
            ref={setNodeRef}
            className="column"
            style={{
                minHeight: "160px",
                padding: "10px",
                background: "rgba(255,255,255,0.2)",
                borderRadius: "8px",
                border: isOver ? "2px dashed #fff" : "2px solid transparent",
                flex: 1,
            }}
        >
            <h2>{column.title}</h2>

            <SortableContext items={column.cards.map((card) => card.id)} strategy={verticalListSortingStrategy}>
                {column.cards.map((card) => (
                    <Card key={card.id} card={card} />
                ))}
            </SortableContext>

            {column.id === "col1" && column.cards.length === 0 && (
                <div style={{ color: "#ddd", fontStyle: "italic", margin: "8px 0" }}>
                    Drag your card here or add it below ↓
                </div>
            )}

            {column.id === "col1" && (
                <>
                    <input
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        placeholder="New Task"
                        style={{ width: "100%", padding: "6px", marginTop: "10px" }}
                    />
                    <button
                        onClick={addCard}
                        style={{ marginTop: "6px", width: "100%" }}
                    >
                        Add Card
                    </button>
                </>
            )}
        </div>
    );
}